import { useReviewCreationData, useValidationAcknowledgements } from 'reducers/reviewCreationSlice';

import NoFeedImage from 'assets/assetsV1/illustrations/noFeed.svg';

import { EmptyScreen } from 'uiToolkitV1/EmptyScreen';
import { ListWarning } from 'uiToolkitV1/ListWarning';
import { Paper, PaperWithShadow } from 'uiToolkitV1/Paper';

import {
  useGetGoalsMissing,
  useGetGradeMissing,
  useGetOverlappingEmployees,
  useManagerMissing,
} from '../../Hooks/dataHooks/validationDataHooks';
import { useReviewCreationNavigation } from '../../Hooks/useReviewCreationNavigation';
import { ReviewCreationFooter } from '../../ReviewCreationFooter';
import { GoalsMissingValidation } from './GoalsMissingValidation';
import { GradeMissingValidation } from './GradeMissingValidation';
import { ManagerMissingValidation } from './ManagerMissingValidation';
import { MultipleViewsValidation } from './MultipleViewsValidation';

const Footer = () => {
  const validations = useValidationAcknowledgements();
  const { goToNextStep } = useReviewCreationNavigation();

  const isContinueDisabled =
    validations.hasEmployeesWithMultipleViews ||
    !validations.isManagerMissingAcknowledged ||
    !validations.isGoalsMissingAcknowledged ||
    !validations.isGradesMissingAcknowledged;

  return <ReviewCreationFooter isContinueDisabled={isContinueDisabled} onContinue={goToNextStep} />;
};

export const Validation = () => {
  const { reviewCycleId } = useReviewCreationData();

  const {
    data: dataGrade,
    isLoading: isLoadingGrade,
    isSuccess: isSuccessGrade,
  } = useGetGradeMissing({ reviewCycleId });
  const {
    data: dataGoals,
    isLoading: isLoadingGoals,
    isSuccess: isSuccessGoals,
  } = useGetGoalsMissing({ reviewCycleId });
  const {
    data: dataManager,
    isLoading: isLoadingManager,
    isSuccess: isSuccessManager,
  } = useManagerMissing({ reviewCycleId });
  const {
    data: dataOverlapping,
    isLoading: isLoadingOverlapping,
    isSuccess: isSuccessOverlapping,
  } = useGetOverlappingEmployees({ reviewCycleId });

  if (
    isSuccessGoals &&
    isSuccessGrade &&
    isSuccessManager &&
    isSuccessOverlapping &&
    dataGoals.length === 0 &&
    dataGrade.length === 0 &&
    dataManager.length === 0 &&
    dataOverlapping.length === 0
  ) {
    return (
      <>
        <ListWarning warningText="This section will not be accessible after the review cycle has been launched (only visible in the Draft mode)" />
        <Paper p="16px 16px 16px 24px" w="100%">
          {/* @ts-ignore */}
          <EmptyScreen
            heading="This review does not need any validations"
            description="Skip ahead to the next step from the navigation below"
            illustrationSrc={NoFeedImage}
          />
        </Paper>

        <Footer />
      </>
    );
  }

  return (
    <>
      <PaperWithShadow p="0">
        <ListWarning warningText="This section will not be accessible after the review cycle has been launched (only visible in the Draft mode)" />
      </PaperWithShadow>

      <MultipleViewsValidation />
      <ManagerMissingValidation />
      <GoalsMissingValidation />
      <GradeMissingValidation />
      <Footer />
    </>
  );
};
